<template lang="html">
  <v-card-actions class="actions">
    <Spacer />
    <slot>
      <StandardButton />
    </slot>
  </v-card-actions>
</template>

<script>
import StandardButton from './StandardButton'
import Spacer from './Spacer'

export default {
  components: {
    StandardButton,
    Spacer
  }
}
</script>

<style lang="css" scoped>
</style>
